export default class LoginModel {
    public login: string;
    public password: string;
    public remember: boolean;
}